/**
 * Category A salaried income, employment-only route (golden case 3). MET
 * when gross annual income reaches the applicable threshold. A shortfall is
 * NOT_MET with the gap in pounds and a factual note that the rules allow
 * cash savings to cover it — stating what the rules allow, never what this
 * person should do.
 */
import type { EvaluatePredicate } from "./predicate.js";

export const cat_a_salaried_income: EvaluatePredicate = (facts, _rule, ctx) => {
  const thresholdResult = ctx.results.get("FIN.THRESHOLD");
  if (!thresholdResult || thresholdResult.status !== "MET") {
    return {
      status: "PENDING_EVIDENCE",
      because: ["FIN.THRESHOLD"],
      notes: ["The income requirement cannot be assessed until the applicable threshold is determined."],
    };
  }
  const threshold = thresholdResult.figures?.["threshold"];
  if (threshold === undefined) throw new Error("FIN.THRESHOLD result carries no threshold figure");

  const income = facts.finances.sponsor_employment?.gross_annual ?? null;
  if (income === null) {
    return {
      status: "PENDING_EVIDENCE",
      because: ["FIN.THRESHOLD"],
      notes: ["The gross annual salary is needed."],
    };
  }

  const headroom = income - threshold;
  const figures = { threshold, income, headroom };

  if (income >= threshold) {
    return { status: "MET", figures, because: ["FIN.THRESHOLD"] };
  }
  return {
    status: "NOT_MET",
    figures,
    because: ["FIN.THRESHOLD"],
    notes: [
      "The gross annual salary is below the applicable figure. The rules allow cash savings, held for 6 months, to cover a shortfall.",
    ],
  };
};
